import React, {useRef} from 'react';
import { EChart as ReactECharts } from '../EChart';
import * as echarts from 'echarts/core';
import ReactEChartsCore from '../EChart';
import {
  GaugeChart
} from 'echarts/charts';
import {
  TooltipComponent
} from 'echarts/components';
import {
  CanvasRenderer
} from 'echarts/renderers';
import { Card } from 'react-bootstrap';

echarts.use([
  TooltipComponent,
  GaugeChart,
  CanvasRenderer
]);

const MachinePowerPercentage = ({name}) => {
    const chartRef = useRef(null)

    const option = {
      title: {
        text: name,
      },
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%'
        },
        series: [
          {
            name: 'Pressure',
            type: 'gauge',
            progress: {
              show: true
            },
            detail: {
              valueAnimation: true,
              formatter: '{value}'
            },
            detail: {
              valueAnimation: true,
              fontSize: 24,
              offsetCenter: [0, '80%']
            },
            data: [
              {
                value: 50,
                name: 'SCORE'
              }
            ]
          }
        ]
      };
    
  return (
    <Card className="h-100">
    <Card.Body className='d-flex justify-content-center'>
      <ReactEChartsCore
         ref={chartRef}
         echarts={echarts}
         option={option}
         style={{ height: '316px', width: '120%' }}
       />
    </Card.Body>
</Card>
  )
}

export default MachinePowerPercentage